export const FILTERS_FORM_ID = "filters-bar";
export const FILTER_SEARCH_ID = "filter-search";
export const FILTER_SEARCH_INPUT_SELECTOR = `#search-bar`;

export const FILTERS_BUTTON_SELECTOR = '#filters-button';

export const FILTER_NAMES: {
    OPERATION_TYPE: string,
    PROPERTY_TYPE: string,
    PRICE: string,
    ROOMS: string,
    BATHROOMS: string,
    AREA: string,
    SORTING: string,
    GEO_ID: string,
    TEXT: string,
} = {
    OPERATION_TYPE: "operationType",
    PROPERTY_TYPE: "propertyType",
    PRICE: "price",
    ROOMS: "rooms",
    BATHROOMS: "bathrooms",
    AREA: "area",
    SORTING: "sorting",
    GEO_ID: "hidden-geo-id",
    TEXT: "text",
};
export const MODAL_FILTERS_SELECTOR = '.filters-section .filter-option';
export const MODAL_FILTERS_CONTAINER_SELECTORS: {[key: string]: string} = {
    [FILTER_NAMES.OPERATION_TYPE]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-operation-type`,
    [FILTER_NAMES.PROPERTY_TYPE]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-property-type`,
    [FILTER_NAMES.PRICE]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-price`,
    [FILTER_NAMES.ROOMS]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-bedrooms`,
    [FILTER_NAMES.BATHROOMS]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-bathrooms`,
    [FILTER_NAMES.AREA]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-area`,
    [FILTER_NAMES.SORTING]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-sorting`,
}
export const FILTERS_FORM_MODAL_SELECTOR = '#filters-form-bar';
export const FILTERS_MODAL_FORM_SELECTOR = "#filters-form-bar";
export const FILTERS_BAR_FORM_SELECTOR = "#filters-bar";